import React, { useState } from 'react';
import './AlertsBanner.css';

interface WeatherAlert {
  id: number;
  type: string;
  severity: string;
  headline: string;
  description: string;
  alert_date: string;
  animal_types: string[];
}

interface AlertsBannerProps {
  weatherAlerts: WeatherAlert[];
  lowFeedAlerts?: never[];  // Deprecated - low feed alerts now shown in FeedStatusCard
  onDismissWeather?: (id: number) => void;
}

const AlertsBanner: React.FC<AlertsBannerProps> = ({
  weatherAlerts,
  onDismissWeather
}) => {
  const [dismissedWeather, setDismissedWeather] = useState<Set<number>>(new Set());

  const handleDismissWeather = (id: number) => {
    setDismissedWeather(prev => {
      const newSet = new Set(prev);
      newSet.add(id);
      return newSet;
    });
    onDismissWeather?.(id);
  };

  const visibleWeatherAlerts = weatherAlerts.filter(a => !dismissedWeather.has(a.id));

  // Only show weather alerts - low feed alerts are now shown in FeedStatusCard
  if (visibleWeatherAlerts.length === 0) {
    return null;
  }

  return (
    <div className="alerts-banner">
      {/* Weather Alerts Only */}
      {visibleWeatherAlerts.map(alert => (
        <div
          key={`weather-${alert.id}`}
          className={`alert-banner alert-weather alert-${alert.severity}`}
        >
          <div className="alert-banner-icon">
            {alert.severity === 'extreme' || alert.severity === 'severe' ? '🚨' : '⚠️'}
          </div>
          <div className="alert-banner-content">
            <div className="alert-banner-title">WEATHER ALERT</div>
            <div className="alert-banner-message">{alert.headline}</div>
            {alert.animal_types.length > 0 && (
              <div className="alert-banner-animals">
                Affects: {alert.animal_types.join(', ')}
              </div>
            )}
          </div>
          <button
            className="alert-banner-dismiss"
            onClick={() => handleDismissWeather(alert.id)}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AlertsBanner;
